import React, { FC } from "react";

export type ProgressBarProps = {
  percent: number;
  strokeColor?: string;
  style?: React.CSSProperties;
};

export const ProgressBar: FC<ProgressBarProps> = ({ percent, strokeColor = "#1890ff", style }) => {
  const safePercent = Math.min(100, Math.max(0, percent));
  return (
    <div
      style={{
        ...style,
        borderRadius: "5px",
        display: "inline-block",
        width: "100%",
      }}
    >
      <svg width="100%" height="10">
        <rect width="100%" height="100%" fill="#e6e6e6" rx="5" />
        <rect width={`${safePercent}%`} height="100%" fill={strokeColor} rx="5" />
      </svg>
    </div>
  );
};
